// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Zimbabwe */
const ZW = /^(?:7(?:[1278]\d|3[1-9]|9[01])\d{6})$/;

export default ZW;
